/**
 * Websocket data types
 * @public
 */
export enum HoruzProtocolChulakDataType {
  AUTH = 0x1000,
  AUTH_COMPLETED = 0x1001,

  STATE_AGENT_START_ENTER = 0x2000,
  STATE_AGENT_START_EXIT = 0x2001,
  STATE_APP_PAIRING_ENTER = 0x2003,
  STATE_APP_PAIRING_EXIT = 0x2004,
  STATE_APP_PRESENTATION_ENTER = 0x2005,
  STATE_APP_PRESENTATION_EXIT = 0x2006,

  DATA_AGENT_START_COMPLETED = 0x3001,
  DATA_APP_PAIRING_COMPLETED = 0x3002,
  DATA_APP_PRESENTATION_COMPLETED = 0x3003,
  DATA_SESSION_ABORTED = 0x3004,
  DATA_APP_TAGS_REFRESHED = 0x3005,
}

/**
 * Version
 * @public
 */
export const HoruzProtocolChulakDataVersion = 0x04;
